<svg:line
    class="grid-hor"
    *ngFor="let tick of ticks"
    [attr.x1]="0"
    [attr.x2]="dimensions.boundedWidth"
    [attr.y1]="scale(tick)"
    [attr.y2]="scale(tick)"
></svg:line>

